@if (!isLoading) {
  <div class="section" style="flex: 1; display: flex; flex-direction: column; height: 100%; max-height: 100%; overflow: hidden;" data-cy="ar-payment-audit">
    <div class="section-header" data-cy="ar-payment-audit-header">
      <div class="section-header-title" data-cy="ar-payment-audit-title">Payment Audit</div>
    </div>
    <div class="section-content" style="display: flex; flex-direction: column; flex: 1; overflow: hidden;" data-cy="ar-payment-audit-content">
      <div style="flex: 2; overflow-y: auto; height: 490px; margin-top: 0px;" data-cy="ar-payment-audit-table-container">
        <tdo-table [dataSource]="this.dataARPayments"
          [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"
          [footerData]="footerData" [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)" data-cy="ar-payment-audit-table">
          <tdo-table-column displayName="Payment Date" propertyName="PaymentTransactionDate" isSortable="true" [rowTemplate]="paymentDate" data-cy="ar-payment-audit-col-date">
            <ng-template #paymentDate let-row>
              @if (row.PaymentTransactionDate) {
                <div data-cy="ar-payment-audit-date">{{ row.PaymentTransactionDate | date }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Patient" propertyName="PatientFirstName" isSortable="true" [rowTemplate]="patientName" data-cy="ar-payment-audit-col-patient">
            <ng-template #patientName let-row>
              @if (row.PatientFirstName) {
                <div data-cy="ar-payment-audit-patient">
                  <a class="link_button" (click)="redirectToPatientLedger(row.PatientId, row.model.PatientFirstName + ' ' + row.model.PatientLastName)" data-cy="ar-payment-audit-patient-link">{{ row.model.PatientFirstName + ' ' + row.model.PatientLastName }}</a>
                </div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="From" propertyName="PayerFirstName" isSortable="true" [rowTemplate]="payerName" data-cy="ar-payment-audit-col-payer">
            <ng-template #payerName let-row>
              @if (row.PayerFirstName) {
                <div data-cy="ar-payment-audit-payer">{{ row.model.PayerFirstName + ' ' + row.model.PayerLastName }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Amount" propertyName="PaymentAmount" isSortable="true" [rowTemplate]="paymentAmount" data-cy="ar-payment-audit-col-amount">
            <ng-template #paymentAmount let-row>
              @if (row.PaymentAmount) {
                <div data-cy="ar-payment-audit-amount">{{ row.PaymentAmount | currency }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Description" propertyName="Description" isSortable="true" [rowTemplate]="description" data-cy="ar-payment-audit-col-description">
            <ng-template #description let-row>
              @if (row.model.Description) {
                <div data-cy="ar-payment-audit-description">{{ row.model.Description }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Status" propertyName="PaymentStatus" isSortable="true" [rowTemplate]="status" data-cy="ar-payment-audit-col-status">
            <ng-template #status let-row>
              @if (row.model.PaymentStatus) {
                <div data-cy="ar-payment-audit-status">{{ row.model.PaymentStatus }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Processor" propertyName="PaymentProcessorName" isSortable="true" [rowTemplate]="processor" data-cy="ar-payment-audit-col-processor">
            <ng-template #processor let-row>
              <div data-cy="ar-payment-audit-processor">
                <!--            <div *ngIf="row.model.PaymentProcessorName">-->
                <a class="link_button" (click)="ViewTransactionDetails(row.model.PaymetnID, row.model.PaymentTransactionId, row.model.enumARProcessorID)" data-cy="ar-payment-audit-processor-link">
                  {{ row.model.PaymentProcessorName }}
                </a>
              </div>
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
      <div style="flex: 1; overflow-y: auto; height: 490px; margin-top: 20px;" data-cy="ar-payment-audit-logs-container">
        <tdo-table [dataSource]="this.dataARPaymentLogs"
          [isMultiSelection]="false" [isSearchable]="false" [isUsePaginator]="false"
          [footerData]="footerData" [searchPredicate]="searchPredicate" (rowSelected)="onRowSelectedLog($event)" data-cy="ar-payment-audit-logs-table">
          <tdo-table-column displayName="Log Date" propertyName="LogDate" isSortable="true" [rowTemplate]="logDate" data-cy="ar-payment-audit-logs-col-date">
            <ng-template #logDate let-row>
              @if (row.LogDate) {
                <div data-cy="ar-payment-audit-logs-date">{{ row.LogDate | date }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Log Type" propertyName="LogType" isSortable="true" [rowTemplate]="logType" data-cy="ar-payment-audit-logs-col-type">
            <ng-template #logType let-row>
              @if (row.LogType) {
                <div data-cy="ar-payment-audit-logs-type">{{ row.LogType }}</div>
              }
            </ng-template>
          </tdo-table-column>
          <tdo-table-column displayName="Log Text" propertyName="LogText" isSortable="true" [rowTemplate]="logText" data-cy="ar-payment-audit-logs-col-text">
            <ng-template #logText let-row>
              @if (row.LogText) {
                <div data-cy="ar-payment-audit-logs-text">
                  @if (returnShortenedLogText(row.LogText)) {
                    <div data-cy="ar-payment-audit-logs-text-shortened">
                      {{ returnShortenedLogText(row.LogText) }}...&nbsp;&nbsp;&nbsp;
                      <a class="link_button" (click)="showFullLogText(row.LogText)" data-cy="ar-payment-audit-logs-text-view-full">View Full Log</a>
                    </div>
                  }
                  @if (!returnShortenedLogText(row.LogText)) {
                    <div data-cy="ar-payment-audit-logs-text-full">{{ row.LogText }}</div>
                  }
                </div>
              }
            </ng-template>
          </tdo-table-column>
        </tdo-table>
      </div>
    </div>
  </div>
}

@if (isLoading) {
  <div class="spinner-container" data-cy="ar-payment-audit-spinner-container">
    <mat-spinner data-cy="ar-payment-audit-spinner"></mat-spinner>
  </div>
}
